<script setup lang="ts">
import type { HeroBlock } from '../../types'
import SiteEditableText from '../../SiteEditableText.vue'
import SiteImageAttribution from '../../SiteImageAttribution.vue'
import SiteLink from '../../SiteLink.vue'

defineProps<{ block: HeroBlock }>()
</script>

<template>
  <section
    class="site:relative site:flex site:min-h-[38rem] site:items-center site:overflow-hidden site:bg-(--site-color-text) site:py-20 site:text-white"
  >
    <figure
      v-if="block.content.image"
      class="site:absolute site:inset-0 site:h-full site:w-full"
    >
      <img :src="block.content.image.src" alt="" class="site:h-full site:w-full site:object-cover" fetchpriority="high" />
      <SiteImageAttribution v-if="block.content.image.attribution" :image="block.content.image" class="site:absolute site:bottom-2 site:right-2 site:z-20" />
    </figure>
    <div class="site:absolute site:inset-0 site:bg-gradient-to-r site:from-black/80 site:to-black/25" />
    <div class="site-site-container site:relative">
      <div class="site:max-w-2xl">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-white/80" />
        <SiteEditableText v-model="block.content.heading" as="h1" class="site-heading site:mt-4 site:text-4xl site:font-bold site:tracking-tight site:@min-[40rem]:text-6xl" />
        <SiteEditableText v-model="block.content.description" as="p" class="site:mt-6 site:text-lg site:leading-8 site:text-white/80" />
        <div class="site:mt-8 site:flex site:flex-wrap site:gap-3">
          <SiteLink class="site-site-button" :link="block.content.primaryAction">
            {{ block.content.primaryAction.label }}
          </SiteLink>
          <SiteLink
            v-if="block.content.secondaryAction"
            class="site:inline-flex site:items-center site:justify-center site:rounded-(--site-radius-sm) site:border site:border-white/50 site:px-4 site:py-3 site:text-sm site:font-semibold site:text-white"
            :link="block.content.secondaryAction"
          >
            {{ block.content.secondaryAction.label }}
          </SiteLink>
        </div>
        <ul v-if="block.content.highlights?.length" class="site:mt-12 site:flex site:flex-wrap site:gap-x-6 site:gap-y-3 site:text-sm site:font-medium site:text-white/85 site:@min-[40rem]:mt-14">
          <SiteEditableText v-for="(_, index) in block.content.highlights" :key="index" v-model="block.content.highlights![index]" as="li" />
        </ul>
      </div>
    </div>
  </section>
</template>
